import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import moment from 'moment';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

export type GAHMatPopupData = {
  title: string;
  hasTable: boolean;
  rowData: any[];
};
@Component({
  selector: 'app-gah-mat-popup',
  templateUrl: './gah-mat-popup.component.html',
  styleUrls: ['./gah-mat-popup.component.scss'],
})
export class GahMatPopupComponent {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GAHMatPopupData,
    public dialogRef: MatDialogRef<GahMatPopupComponent>,
    private translate: TranslateService,
  ) {}

  close() {
    this.dialogRef.close();
  }

    calculateReleaseDate(rowData) {
    let months: string[] = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let dt: any;
    let month: any;
    let year: any;
    let result: string = '';

    if (rowData.formattedReleaseDate) {
      if (rowData.releaseDatePrecisionFlag == 'M') {
        dt = new Date(rowData.formattedReleaseDate);
        month = months[dt.getMonth()];
        year = dt.getFullYear();
        return month + ' ' + year;
      } else if (rowData.releaseDatePrecisionFlag == 'Y') {
        moment(rowData.formattedReleaseDate);
        dt = new Date(rowData.formattedReleaseDate);
        year = dt.getFullYear();
        return year.toString();
      } else if (rowData.releaseDatePrecisionFlag == 'Q') {
        moment(rowData.formattedReleaseDate);
        dt = new Date(rowData.formattedReleaseDate);
        year = dt.getFullYear();
        month = dt.getMonth();
        if (month < 4) {
          result = 'Q1' + ' ' + year;
        } else if (month > 3 && month < 7) {
          result = 'Q2' + ' ' + year;
        } else if (month > 6 && month < 10) {
          result = 'Q3' + ' ' + year;
        } else {
          result = 'Q4' + ' ' + year;
        }
        return result;
      } else {
        return rowData.formattedReleaseDate;
      }
    } else {
      return '';
    }
  }

}
